import { action } from "satcheljs";

const teamSettingsChanged = action(
    "TEAM_SETTINGS_CHANGED", () => ({})
);

export default teamSettingsChanged;
